import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

/** Sends each signed-in user to their own landing page. */
export function HomePage() {
  const { me } = useAuth();

  if (me?.kind === "staff") {
    return <Navigate to="/staff/sharings" replace />;
  }
  return <Navigate to="/files" replace />;
}
